<template>
    <div class="dropdown w-100">
        <button class="btn btn-secondary btn-block text-left bg-white text-dark dropdown-toggle" type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-if="selectedStates?.length === 0" class="text-muted">
                {{ __('actions.select_thing', {thing: __('general.status')}) }}
            </span>
            <span v-else class="d-inline-block">
                <span class="d-flex flex-row gap-1">
                    <Badge v-for="orderState in selectedStates?.slice(0, previewLimit)"
                           :key="orderState"
                           class="font-size-xs"
                    >
                        {{ __('orders.states.' + orderState) }}
                    </Badge>
                    <Badge v-if="selectedStates?.length > previewLimit" class="font-size-xs">
                        +{{ selectedStates?.length - previewLimit }}
                    </Badge>
                </span>
            </span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li v-for="orderState in OrderState" class="px-4 py-2" @click.stop>
                <Checkbox :value="selectedStates?.includes(orderState)"
                          @input="checked => updateSelectedStates(orderState, checked)" class="bg-hover-light-light">
                    <div class="text-uppercase">
                        {{ __('orders.states.' + orderState) }}
                    </div>
                </Checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import Checkbox from "@components/Form/Checkbox.vue";
import OrderTypeIcon from "@components/Orders/OrderTypeIcon.vue";
import Badge from "@components/Badge.vue";
import OrderTypeBadge from "@components/Orders/OrderTypeBadge.vue";
import {OrderState} from '@generated/orderState';

export default {
    computed: {
        OrderState() {
            return OrderState
        }
    },
    components: {OrderTypeBadge, Badge, OrderTypeIcon, Checkbox},

    props: {
        previewLimit: {
            type: Number,
            default: 3
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            selectedStates: this.value
        }
    },

    methods: {
        updateSelectedStates(orderState, checked) {
            if (checked && !this.selectedStates.includes(orderState)) {
                this.selectedStates.push(orderState);
            } else if (!checked && this.selectedStates.includes(orderState)) {
                this.selectedStates.splice(this.selectedStates.indexOf(orderState), 1);
            }
            this.$emit('input', this.selectedStates)
        }
    },
}
</script>
